import { ElementsContext } from "@/lib/context";
import { useContext } from "react";

export const useElements = () => {
  const context = useContext(ElementsContext);

  if (!context) {
    throw new Error("Please use within ElementProvider");
  }

  return context;
};
